import React from 'react';
import styles from '../styles/common.less';
const Tip = ({ text, children }) => {
  return (
    <div className={styles.tip}>
      {text}
      {children}
    </div>
  );
};
export default Tip;
